import React, { useState, Component, useEffect } from 'react';
import { connect } from 'react-redux';
import { Button, Icon } from '@salesforce/design-system-react';

import HeroCollectionCard from './HeroCollectionCard';
import EnablementCards from './EnablementCards';

let heroCards = [
    {
        imgUrl: '/logos/paypal_logo.png',
        titleUrl:
          'https://solutionscentral.io/posts/b40d8f70-f2c8-11ea-b89e-3f0475b8d21d/paypal-hero-output/',
        title: 'Paypal',
        description:
          'Creating a safe and seamless financial ecosystem that grows to 1 billion users',
        tags: [],
    },
    {
      imgUrl: '/logos/zoom_logo.png',
      titleUrl:
        'https://solutionscentral.io/posts/a1d625a0-a810-11e9-bca8-cfbca3a25b59/zoom-hero-output/',
      title: 'Zoom',
      description:
        'Scaling Zoom’s internal experience beyond the rapid success of their customers',
      tags: [],
    },

    {
      imgUrl: '/logos/snowflake_logo.png',
      titleUrl:
        'https://solutionscentral.io/posts/15814480-f383-11ea-bd24-e32369e15cd9/hero-snowflake/',
      title: 'Snowflake',
      description:
        'Unlocking the full power of partnership to spark a data revolution',
      tags: [],
    }];

const EntrySidebar = (props) => {
    return (
        <div className="entry-sidebar">
            <div className="slds-p-bottom_medium" style={{ height: '10%'}}>
                <div 
                    className="slds-p-top_large slds-p-bottom_small slds-align_absolute-center" 
                    style={{ color: "white", fontSize: "1.85rem"}}
                    
                >
                    <a href="/" style={{ color: 'white', textDecoration: 'none'}}>HERO6</a>
                </div> 
                <div 
                    className="slds-text-title_caps slds-align_absolute-center" 
                    style={{ color: "white", fontSize: '.575rem' }}
                >
                    Align Your Team. Create A Future Vision.
                </div>
            </div>
            <div style={{ height: '45%'}} className="slds-p-top_large">
                  <div 
                    className="slds-p-left_small" 
                    style={{ color: "white", fontSize: "1rem", color: 'white', borderBottom: '1px solid #eee'}}
                  >Enablement</div> 
              <EnablementCards stage="Entry" />
            </div>
            <div style={{ height: '40%'}}>
                <div className="slds-grid slds-p-top_large ">
                  <div 
                      className="slds-p-left_small slds-size_3-of-4" 
                      style={{ color: "white", fontSize: "1rem"}}
                  >Testimonials</div> 
                  <div className="slds-size_1-of-4 slds-align_absolute-center">
                    <Button
                      iconCategory="utility"
                      iconName="new_window"
                      iconPosition="right"
                      variant="link"
                      style={{ color: 'white'}}
                      onClick={(e) =>
                        window.open(
                          'https://solutionscentral.io/collections/c4debec0-562d-11e9-8f76-3d12a8630590/hero-outputs/',
                          '_blank'
                        )
                      }
                    />
                  </div>
                </div>
                {heroCards.map((card) => (
                  <div
                    key={card.content}
                  >
                    <HeroCollectionCard {...card} />
                  </div>
                ))}
            </div>
            <div 
                className="slds-align_absolute-center" 
                style={{ fontSize: '.8rem', color: 'white', color: 'white', borderTop: '1px solid #eee', height: '5%'}}
            ><span className="slds-p-right_small"><Icon category="utility" name="user" size="x-small" style={{ fill: '#fff'}} /></span> <strong>{props.username}</strong></div>
        </div>
    )
};

const mapStateToProps = (state) => ({
    username: state.app.username,
});

const mapDispatchToProps = (dispatch) => ({});
  
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EntrySidebar);
